export const DATA_TEST_ID = `overlay`
export const RESUME_BUTTON_LABEL = 'Resume'
export const BODY_TEXT =
  "Resume to keep learning. Don't worry-your progress has been saved."
export const HEADER_TEXT1 = 'Still there?'
